import React, { useState, ReactNode } from 'react';
import AppHeader from './Header';
import Sidebaar from './Sidebar';
import { Layout } from 'antd';

const { Content } = Layout;

interface BaseProps {
  children?: ReactNode;
}

const Base: React.FC<BaseProps> = (props) => {
  const [collapsed, setCollapsed] = useState<boolean>(window.innerWidth < 645);

  const toggle = (): void => {
    setCollapsed(!collapsed);
  };

  const overlayhide = (): void => {
    if (window.innerWidth < 645) {
      setCollapsed(true);
    }
  };

  return (
    <Layout>
      <div
        className={collapsed ? 'hide' : 'overlay-backdrop'}
        onClick={overlayhide}
      ></div>
      <Sidebaar trigger={null} collapsible collapsed={collapsed} />
      <Layout>
        <AppHeader collapsed={collapsed} toggle={toggle} user={props} />
        <Content>
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default Base;
